import { render, staticRenderFns } from "./SelectMerchantGroup.vue?vue&type=template&id=0b9dce65&lang=pug"
import script from "./SelectMerchantGroup.vue?vue&type=script&lang=js"
export * from "./SelectMerchantGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports